"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _core = require("@clayui/core");

var _shared = require("@clayui/shared");

var _react = _interopRequireDefault(require("react"));

var _excluded = ["alignmentPosition", "disabled", "disabledPages", "hrefConstructor", "items", "onPageChange"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Item = _core.__EXPERIMENTAL_MENU.Item,
    Menu = _core.__EXPERIMENTAL_MENU.Menu;

var ClayPaginationEllipsis = function ClayPaginationEllipsis(_ref) {
  var _alignmentPosition = _ref.alignmentPosition,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disabledPages = _ref.disabledPages,
      disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages,
      hrefConstructor = _ref.hrefConstructor,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      onPageChange = _ref.onPageChange,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var ariaLabel = otherProps['aria-label'] && !disabled ? (0, _shared.sub)(otherProps['aria-label'], [String(items[0]), String(items[items.length - 1])]) : undefined;
  var title = otherProps['title'] && !disabled ? (0, _shared.sub)(otherProps['title'], [String(items[0]), String(items[items.length - 1])]) : undefined;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "page-item"
  }, /*#__PURE__*/_react.default.createElement(Menu, {
    disabled: disabled,
    items: items,
    trigger: /*#__PURE__*/_react.default.createElement(_button.default, _extends({}, otherProps, {
      "aria-label": ariaLabel,
      className: "page-link",
      displayType: "unstyled",
      title: title
    }), "...")
  }, function (item) {
    return /*#__PURE__*/_react.default.createElement(Item, {
      disabled: disabledPages.includes(item),
      href: hrefConstructor ? hrefConstructor(item) : undefined,
      key: item,
      onClick: function onClick() {
        return onPageChange && onPageChange(item);
      }
    }, String(item));
  }));
};

var _default = ClayPaginationEllipsis;
exports.default = _default;